// extracted by mini-css-extract-plugin
export default {"Container":"Invoice_Container__wboyn","ButtonsList":"Invoice_ButtonsList__LE1Q7","Price":"Invoice_Price__d6EW3","Total":"Invoice_Total__HyeCn"};